import { render, staticRenderFns } from "./orderclose.vue?vue&type=template&id=41155902&scoped=true"
import script from "./orderclose.vue?vue&type=script&lang=js"
export * from "./orderclose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41155902",
  null
  
)

export default component.exports